export default class CreatePaymentRefundItem {
  constructor() {
    this.ClientPaymentId = '';
    this.RefundedOn = new Date();
    this.ReasonCode = '';
    this.MethodCode = '';
    this.Amount = '';
    this.TransactionReference = '';
    this.Comment = '';
  }
}
